/* ============================================
   GIFT CARD PAGE
   - Title glitch (matches contact/policy pattern)
   - AJAX submit so the form doesn't reload the page;
     on success show "GIFT CARD ADDED" inline and
     publish a cart:refresh event so the cart drawer
     picks up the new line item.
   ============================================ */

(function () {
  if (window.__giftCardInit) return;
  window.__giftCardInit = true;

  // ----- Title glitch (matches contact / policy effect) -----
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function glitch(el) {
    if (!el || el.__glitching) return;
    el.__glitching = true;
    var original = el.textContent;
    var len = original.length;
    var INTERVAL = 30;
    var DURATION = 360;
    var iterPerFrame = len / (DURATION / INTERVAL);
    var iter = 0;
    var id = setInterval(function () {
      el.textContent = original.split('').map(function (c, i) {
        if (i < iter) return original[i];
        if (!/[A-Za-z]/.test(c)) return c;
        return CHARS[Math.floor(Math.random() * CHARS.length)];
      }).join('');
      iter += iterPerFrame;
      if (iter >= len) {
        clearInterval(id);
        el.textContent = original;
        el.__glitching = false;
      }
    }, INTERVAL);
  }

  function scheduleGlitch() {
    var title = document.querySelector('[data-gc-title]');
    if (!title) return;
    var fire = function () { setTimeout(function () { glitch(title); }, 1100); };
    if (document.readyState === 'complete') fire();
    else window.addEventListener('load', fire, { once: true });
  }

  // ----- AJAX cart add -----
  function setSubmitting(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    var span = btn.querySelector('.gift-card-page__submit-text');
    if (span) span.textContent = on ? 'ADDING…' : 'SEND GIFT CARD';
  }

  function showSuccess(form, wrap) {
    if (!wrap) return;
    wrap.setAttribute('data-gc-state', 'added');
    // Reset form values after a moment so the next purchase starts clean
    setTimeout(function () {
      if (form && typeof form.reset === 'function') form.reset();
    }, 400);
  }

  function showError(btn, msg) {
    if (!btn) return;
    var span = btn.querySelector('.gift-card-page__submit-text');
    if (span) span.textContent = (msg || 'TRY AGAIN').toUpperCase();
    btn.disabled = false;
    setTimeout(function () {
      if (span) span.textContent = 'SEND GIFT CARD';
    }, 2400);
  }

  function bindForm() {
    var form = document.querySelector('[data-gc-form]');
    if (!form || form.dataset.gcBound) return;
    form.dataset.gcBound = '1';

    var wrap = form.closest('[data-gc-form-wrap]');
    var btn = form.querySelector('[data-gc-submit]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return;

      var fd = new FormData(form);
      // Shopify's /cart/add.js wants quantity; default to 1 if not in form
      if (!fd.has('quantity')) fd.append('quantity', '1');

      setSubmitting(btn, true);
      wrap && wrap.removeAttribute('data-gc-state');

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/javascript' }
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && res.data.description) || (res.data && res.data.message) || 'NOT ADDED';
            showError(btn, msg.slice(0, 60));
            return;
          }
          showSuccess(form, wrap);
          setSubmitting(btn, false);
          // Tell the cart drawer/notification to refresh
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: res.data }));
          try {
            if (window.CartDrawer && document.querySelector('cart-drawer')) {
              document.querySelector('cart-drawer').dispatchEvent(new CustomEvent('cart:refresh'));
            }
          } catch (_e) {}
        })
        .catch(function () {
          showError(btn, 'NETWORK ERROR');
        });
    });
  }

  function init() {
    scheduleGlitch();
    bindForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
